import React from 'react';
import {Button} from '@br/br-components';

class RequestPasswordResetForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      error: false,
      success: false,
    };
  }

  componentDidMount() {
    const app =
      this.props.returnUrl && this.props.returnUrl.includes('bracketchallenge') ? 'BCG' : 'BR';
    this.props.trackEvent({
      accountType: 'email',
      app,
      tag_manager_event: 'forgot_password',
    });
  }

  onSubmit(event) {
    event.preventDefault();
    // TODO: Should refactor to use <EmailInput /> when SOC-175 is merged.
    const emailInput = event.target.querySelector("input[name='email']");
    this.setState({
      error: false,
      success: false,
    });

    this.props
      .onSubmit({email: emailInput.value})
      .then(() => {
        this.setState({
          success: true,
        });
      })
      .catch((err) => {
        if (err && err.output && err.output.statusCode === 401) {
          this.setState({
            error: 'No account found.',
          });
        }
      });
  }

  render() {
    const infoMessage = (
      <p>Enter your email and we&#39;ll send you a link to reset your password.</p>
    );
    return (
      <div className="atom requestPasswordResetForm">
        <h1>Reset Password</h1>
        {this.state.success ? (
          <div className="success">
            <p>Link sent! Please check your email.</p>
          </div>
        ) : (
          <form onSubmit={this.onSubmit}>
            {this.state.error ? <p className="errorMessage">{this.state.error}</p> : infoMessage}
            <input
              name="email"
              autoFocus={true}
              type="email"
              required={true}
              placeholder="Email"
              pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
            />
            <Button classes="submit" type="submit">
              Send Link
            </Button>
          </form>
        )}
        {this.props.children}
      </div>
    );
  }
}

export default RequestPasswordResetForm;
